// OutletProximityChart component - Bar chart showing outlets by distance

import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import Card, { CardHeader, CardTitle, CardContent } from '../ui/Card';

const OutletProximityChart = ({ outlets = [], className = '' }) => {
  // Group outlets by distance ranges
  const data = [
    { range: '0-500m', count: 0, color: '#10B981' },
    { range: '500m-1km', count: 0, color: '#F97316' },
    { range: '1-2km', count: 0, color: '#3B82F6' },
    { range: '2-5km', count: 0, color: '#8B5CF6' },
  ];

  outlets.forEach((outlet) => {
    const dist = outlet.distance || 0;
    if (dist <= 500) data[0].count++;
    else if (dist <= 1000) data[1].count++;
    else if (dist <= 2000) data[2].count++;
    else if (dist <= 5000) data[3].count++;
  });

  if (outlets.length === 0) {
    return (
      <Card className={className}>
        <CardHeader>
          <CardTitle>Distance Distribution</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-48 flex items-center justify-center text-dark-400">
            No data available
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>Distance Distribution</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-48">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical" margin={{ left: 20, right: 20 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
              <XAxis type="number" tick={{ fontSize: 12 }} stroke="#94A3B8" />
              <YAxis
                type="category"
                dataKey="range"
                tick={{ fontSize: 12 }}
                stroke="#94A3B8"
                width={70}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#fff',
                  border: '1px solid #E2E8F0',
                  borderRadius: '8px',
                  fontSize: '12px',
                }}
                formatter={(value) => [`${value} outlets`, 'Count']}
              />
              <Bar dataKey="count" radius={[0, 4, 4, 0]}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default OutletProximityChart;
